import { useEffect, useMemo } from 'react';
import Head from 'next/head';
import { Box, Grid } from 'theme-ui';

import { useDataLayerActions } from '@hooks';
import { Icons } from './Details/Icons';
import { Header } from './Header';
import { Media } from './Media';
import { Details } from './Details';
import { themed } from './Main.theme';
import { useProductContext } from '../ProductContext';

export const Main = themed(
  ({ theme, productUpsells, rebuyProducts, videoWise }) => {
    const { product, selectedVariant } = useProductContext();
    const { sendViewProductEvent } = useDataLayerActions();

    const titles = useMemo(() => {
      const titleArr = selectedVariant?.product?.title?.split('|');
      return {
        product: titleArr?.[0]?.trim() || '',
        variant: titleArr?.slice(1)?.join('|').trim() || '',
      };
    }, [selectedVariant?.product?.title]);

    useEffect(() => {
      sendViewProductEvent({ product, selectedVariant });
    }, [selectedVariant?.product?.handle, sendViewProductEvent]);

    return (
      <Grid data-comp={Main.displayName} sx={theme.wrapper}>
        <Head>
          <title>{product?.title || ''}</title>
        </Head>

        <Box sx={{ display: ['block', null, 'none'] }}>
          <Header
            selectedVariant={selectedVariant}
            currentProduct={product}
            titles={titles}
            isMobile
          />
          <Icons product={product} sx={{ marginTop: 2 }} />
        </Box>

        {/* Product images */}
        <Media aboveTheFold preload />

        {/* Title, Options, Add to cart */}
        <Details
          product={product}
          selectedVariant={selectedVariant}
          currentProduct={product}
          titles={titles}
          productUpsells={productUpsells}
          rebuyProducts={rebuyProducts}
        />
      </Grid>
    );
  }
);

Main.displayName = 'Main';
